/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
export default /*#__PURE__*/_defineComponent({
  __name: 'cardPane',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    let active = inject('active');
    return (_ctx, _cache) => {
      return _unref(active) && _unref(active) === __props.name ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true);
    };
  }
});